module.exports = __webpack_public_path__ + "img/DefaultPImageClass.252480be.png";